import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import moment from 'moment';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
  Modal
} from 'react-bootstrap';
import { Field, reduxForm, change } from 'redux-form';

import { closeHistoryModal } from '../../../../actions/modalActions';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../../locale/messages';

import s from './HistoryModal.css';

class HistoryModal extends Component {
  static propTypes = {
    closeHistoryModal: PropTypes.func.isRequired,
    historyModal: PropTypes.bool
  };

  static defaultProps = {
    historyModal: false
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };
  }


  render() {
    const { closeHistoryModal, historyModal, listingHistory } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <Modal show={historyModal} onHide={closeHistoryModal} className={'adminModal'}>
          <Modal.Header closeButton>
            <Modal.Title><FormattedMessage {...messages.history} /></Modal.Title>
          </Modal.Header>
          <Modal.Body bsClass={s.logInModalBody}>
            <div className={cx(s.modalRoot, s.modalBorderBottom, s.historyModalScroll)}>
              {
                listingHistory && listingHistory.map((item, index) => {
                  return (
                    <div className={s.historyListFlex} key={index}>
                      <div className={s.historyListCircle} />
                      <div className={cx(s.historyContent, 'historyContentRTL')}>
                        <p className={s.historyDeclineDate}>{moment(parseInt(item.createdAt)).format('DD MMM, YYYY')} </p>
                        <p className={s.historyDeclineDesc}>{item.reason} - <span className={s.listingReject}><FormattedMessage {...messages.listingRejected} /></span> </p>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

HistoryModal = reduxForm({
  form: 'CommentForm', // a unique name for this form
})(HistoryModal);

const mapState = (state) => ({
  historyModal: state.adminModalStatus.historyModal,
  comment: state.adminModalStatus.comment,
  listingHistory: state.adminModalStatus.listingHistory
});

const mapDispatch = {
  closeHistoryModal,
  change
};

export default compose(
  withStyles(s),
  injectIntl,
  connect(mapState, mapDispatch),
)(HistoryModal);